import React from "react";
import { useLocation } from "react-router-dom";
import "./AboutUs.scss";
import doctorsImg from "../../Assets/doctors.png";
import Navbar from "../Navbar/Navbar";
import PatientAppBar from "../../components/PatientAppBar/PatientAppBar";

export default function AboutUs() {
  const { state } = useLocation();
  const patientBack = state?.patientBack;

  return (
    <div>
      {patientBack ? (
        <PatientAppBar
          title="About us"
          subtitle="HealBid & mission"
          backTo={patientBack.to}
          backLabel={patientBack.label || "Back"}
        />
      ) : (
        <Navbar />
      )}

      <section className="aboutWrap">
        <div className="container">
          <div className="aboutHero">
            <div className="aboutHeroCopy">
              <p className="aboutKicker">About HealBid</p>
              <h1>Building a trusted space where care meets clarity.</h1>
              <p>
                HealBid introduces a smarter and more transparent way for patients and doctors to
                connect. Instead of traditional appointment booking, our platform uses a Bid and
                Reverse Bid system, giving both sides more control, choice, and clarity.
              </p>
            </div>
            <div className="aboutHeroImage">
              <img src={doctorsImg} alt="Medical team" />
            </div>
          </div>

          <div className="aboutGrid">
            <article className="aboutInfoCard">
              <h3>What is Reverse Bid? (Patient-first approach)</h3>
              <p>Reverse Bid starts with the patient.</p>
              <ul>
                <li>Verified doctors review the request.</li>
                <li>Doctors respond with their approach, experience, or consultation details.</li>
                <li>Patients compare options and choose who feels right.</li>
              </ul>
              <p className="aboutSubhead">Why it helps patients</p>
              <ul>
                <li>See multiple medical options in one place.</li>
                <li>Make informed decisions based on clarity and communication.</li>
                <li>Stay in control of your healthcare journey.</li>
              </ul>
            </article>

            <article className="aboutInfoCard">
              <h3>What is Bid? (Doctor-driven engagement)</h3>
              <p>Bid lets doctors actively connect with relevant patient cases.</p>
              <ul>
                <li>Doctors browse requests that match their specialization.</li>
                <li>They submit a bid when they can help.</li>
                <li>Patients review bids and choose the most suitable doctor.</li>
              </ul>
              <p className="aboutSubhead">Why it helps doctors</p>
              <ul>
                <li>Connect with cases aligned to expertise.</li>
                <li>Reduce irrelevant inquiries.</li>
                <li>Build trust through transparent communication.</li>
              </ul>
            </article>

            <article className="aboutInfoCard">
              <h3>Why use Bid &amp; Reverse Bid?</h3>
              <p>
                Traditional healthcare platforms often limit patients to fixed choices. HealBid
                creates a two-way healthcare marketplace:
              </p>
              <ul>
                <li>Patients do not have to guess which doctor to choose.</li>
                <li>Doctors do not have to wait passively for appointments.</li>
                <li>Both sides meet in a transparent, structured environment.</li>
              </ul>
            </article>

            <article className="aboutInfoCard">
              <h3>The result</h3>
              <ul>
                <li>Patients receive personalized medical options.</li>
                <li>Doctors engage with meaningful cases.</li>
                <li>Healthcare becomes more transparent, efficient, and human.</li>
              </ul>
            </article>
          </div>
        </div>
      </section>
    </div>
  );
}